/**
 * 表示に関する便利機能を提供するUtil
 */
export class PlessViewUtils {

  /**
   * 現在日時を指定フォーマットで取得する
   *
   * @param formatString フォーマット文字列(YYYY:年 MM:月 DD:日 hh:時 mm:分 ss:秒)
   */
  static formatedNowDate(formatString: string): string {
    const nowDate = new Date();
    formatString = formatString.replace(/YYYY/g, nowDate.getFullYear().toString());
    formatString = formatString.replace(/MM/g, ('0' + (nowDate.getMonth() + 1)).slice(-2));
    formatString = formatString.replace(/DD/g, ('0' + nowDate.getDate()).slice(-2));
    formatString = formatString.replace(/hh/g, ('0' + nowDate.getHours()).slice(-2));
    formatString = formatString.replace(/mm/g, ('0' + nowDate.getMinutes()).slice(-2));
    formatString = formatString.replace(/ss/g, ('0' + nowDate.getSeconds()).slice(-2));
    return formatString;
  }

  /**
   * 値がnull/undefinedの場合、ブランクを返す
   *
   * @param obj 判定する値
   */
  static nullToBlank(obj: any): string {
    if (obj == null) {
      return '';
    } else {
      return obj.toString();
    }
  }

  /**
   * 値がnull/undefinedの場合、空の配列を返す
   *
   * @param obj 判定する値
   */
  static nullToBlankArray(obj: any): any {
    if (obj == null) {
      return [];
    } else {
      return obj;
    }
  }

  /**
   * 文字列に値があるかどうかを判断する
   * [戻り値]true:空("") or null ／ false:値あり
   *
   * @param value 判定する文字列
   */
  static isEmpty(value: string): boolean {
    if (value == null || value === '') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 配列に値があるかどうかを判断する
   * [戻り値]true:空("") or null ／ false:値あり
   *
   * @param value 判定する文字列
   */
  static isEmptyArray(value: Array<any>): boolean {
    if (value == null) {
      return true;
    } else if (value.length <= 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 全角変換を行う
   *
   * @param value 変換対象文字列
   */
  static halfToFull(value: string): string {
    const letterObj = this.getLetterObject;             // 通常の半角
    const letterObj2byte = this.getLetterObject2byte;   // ｶﾞやﾊﾟなど、2文字が全角1文字になる半角
    let letter: string;
    let letterFull = '';
    for (let i = 0; i < value.length; i++) {
      if ((i + 1) < value.length) {
        letter = value.charAt(i) + value.charAt(i + 1);
        if (letter in letterObj2byte) {
          letter = letterObj2byte[letter];
          letterFull += letter;
          i++;
        } else {
          letter = value.charAt(i);
          if (letter in letterObj) {
            letter = letterObj[letter];
          }
          letterFull += letter;
        }
      } else {
        letter = value.charAt(i);
        if (letter in letterObj) {
          letter = letterObj[letter];
        }
        letterFull += letter;
      }
    }
    return letterFull;
  }

  /**
   * 半角文字と全角文字のマップを取得する
   */
  static get getLetterObject(): object {
    return {
      '0': '０', '1': '１', '2': '２', '3': '３', '4': '４', '5': '５', '6': '６', '7': '７', '8': '８', '9': '９',
      'A': 'Ａ', 'B': 'Ｂ', 'C': 'Ｃ', 'D': 'Ｄ', 'E': 'Ｅ', 'F': 'Ｆ', 'G': 'Ｇ', 'H': 'Ｈ', 'I': 'Ｉ', 'J': 'Ｊ',
      'K': 'Ｋ', 'L': 'Ｌ', 'M': 'Ｍ', 'N': 'Ｎ', 'O': 'Ｏ', 'P': 'Ｐ', 'Q': 'Ｑ', 'R': 'Ｒ', 'S': 'Ｓ', 'T': 'Ｔ',
      'U': 'Ｕ', 'V': 'Ｖ', 'W': 'Ｗ', 'X': 'Ｘ', 'Y': 'Ｙ', 'Z': 'Ｚ',
      'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ', 'f': 'ｆ', 'g': 'ｇ', 'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ',
      'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ', 'o': 'ｏ', 'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ',
      'u': 'ｕ', 'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ', 'z': 'ｚ',
      ' ': '　', '!': '！', '"': '”', '#': '＃', '$': '＄', '%': '％', '&': '＆', '\'': '’', '(': '（', ')': '）',
      '*': '＊', '+': '＋', ',': '，', '-': '－', '.': '．', '/': '／', ':': '：', ';': '；', '<': '＜', '=': '＝',
      '>': '＞', '?': '？', '@': '＠', '[': '［', '\\': '￥', ']': '］', '^': '＾', '_': '＿', '`': '‘', '{': '｛',
      '|': '｜', '}': '｝', '~': '～', '｡': '。', '｢': '「', '｣': '」', '､': '、', '･': '・',
      'ｦ': 'ヲ', 'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ', 'ｯ': 'ッ',
      'ｰ': 'ー',
      'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ', 'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
      'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ', 'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
      'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ', 'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
      'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ', 'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
      'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ', 'ﾜ': 'ワ', 'ﾝ': 'ン',
      'ﾞ': '゛', 'ﾟ': '゜',
   };
  }

  /**
   * 半角文字と全角文字のマップ(濁音・半濁音)
   */
  static get getLetterObject2byte(): object {
    return {
      'ｳﾞ': 'ヴ',
      'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
      'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
      'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
      'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
      'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
    };
  }

  /**
   * 半角変換を行う(半角に変換できない文字は削除)
// 項番2581 START  
　* また、全角入力時の半角への変換を行う
// 項番2581 END
   *
   * @param value 変換対象文字列
   */
  static fullToHalf(value: string): string {
// 項番2581 START
// const letterObj = this.getLetterObject;
    const letterObj = this.getLetterObjectHalfTofull;
// 項番2581 END
    const letterObjFull = this.getLetterObjectFullToFulf;
    let letter: string;
    let letterHalf = '';
    for (let i = 0; i < value.length; i++) {
      letter = value.charAt(i);
      // ASCII印字可能文字(0x21～0x7E)はそのまま通過させる
      const charCode = letter.charCodeAt(0);
      if (charCode >= 0x21 && charCode <= 0x7E) {
        letterHalf += letter;
        continue;
      }
      if (letter in letterObjFull) {
        letter = letterObjFull[letter];
        letterHalf += letter;
      } else if (letter in letterObj) {
        letterHalf += letter;
      }
    }
    return letterHalf;
  }

  /**
   * 全角文字と半角文字のマップ
   */
  static get getLetterObjectFullToFulf(): object {
    return {
      '０': '0', '１': '1', '２': '2', '３': '3', '４': '4', '５': '5', '６': '6', '７': '7', '８': '8', '９': '9',
      'Ａ': 'A', 'Ｂ': 'B', 'Ｃ': 'C', 'Ｄ': 'D', 'Ｅ': 'E', 'Ｆ': 'F', 'Ｇ': 'G', 'Ｈ': 'H', 'Ｉ': 'I', 'Ｊ': 'J',
      'Ｋ': 'K', 'Ｌ': 'L', 'Ｍ': 'M', 'Ｎ': 'N', 'Ｏ': 'O', 'Ｐ': 'P', 'Ｑ': 'Q', 'Ｒ': 'R', 'Ｓ': 'S', 'Ｔ': 'T',
      'Ｕ': 'U', 'Ｖ': 'V', 'Ｗ': 'W', 'Ｘ': 'X', 'Ｙ': 'Y', 'Ｚ': 'Z',
      'ａ': 'a', 'ｂ': 'b', 'ｃ': 'c', 'ｄ': 'd', 'ｅ': 'e', 'ｆ': 'f', 'ｇ': 'g', 'ｈ': 'h', 'ｉ': 'i', 'ｊ': 'j',
      'ｋ': 'k', 'ｌ': 'l', 'ｍ': 'm', 'ｎ': 'n', 'ｏ': 'o', 'ｐ': 'p', 'ｑ': 'q', 'ｒ': 'r', 'ｓ': 's', 'ｔ': 't',
      'ｕ': 'u', 'ｖ': 'v', 'ｗ': 'w', 'ｘ': 'x', 'ｙ': 'y', 'ｚ': 'z',
// 項番2581 START
//    '　': ' ', '！': '!', '”': '"', '＃': '#', '＄': '$', '％': '%', '＆': '&', '’': '\'', '（': '(', '）': ')',
      '　': ' ', '！': '!',           '＃': '#',            '％': '%', '＆': '&',            '（': '(', '）': ')',
//    '＊': '*', '＋': '+', '，': ',', '－': '-', '．': '.', '／': '/', '：': ':', '；': ';', '＜': '<', '＝': '=',
      '＊': '*', '＋': '+',            '－': '-', '．': '.', '／': '/', '：': ':',            '＜': '<', '＝': '=',
//    '＞': '>', '？': '?', '＠': '@', '［': '[', '￥': '\\', '］': ']', '＾': '^', '＿': '_', '‘': '`', '｛': '{',
      '＞': '>', '？': '?',            '［': '[', '￥': '\\', '］': ']', '＾': '^', '＿': '_', '‘': '`', '｛': '{',
//    '｜': '|', '｝': '}', '～': '~', '。': '｡', '「': '｢', '」': '｣', '、': '､', '・': '･',
      '｜': '|', '｝': '}',                       '「': '｢', '」': '｣',
// 項番2581 END
      'ヲ': 'ｦ', 'ァ': 'ｧ', 'ィ': 'ｨ', 'ゥ': 'ｩ', 'ェ': 'ｪ', 'ォ': 'ｫ', 'ャ': 'ｬ', 'ュ': 'ｭ', 'ョ': 'ｮ', 'ッ': 'ｯ',
      'ー': 'ｰ',
      'ア': 'ｱ', 'イ': 'ｲ', 'ウ': 'ｳ', 'エ': 'ｴ', 'オ': 'ｵ', 'カ': 'ｶ', 'キ': 'ｷ', 'ク': 'ｸ', 'ケ': 'ｹ', 'コ': 'ｺ',
      'サ': 'ｻ', 'シ': 'ｼ', 'ス': 'ｽ', 'セ': 'ｾ', 'ソ': 'ｿ', 'タ': 'ﾀ', 'チ': 'ﾁ', 'ツ': 'ﾂ', 'テ': 'ﾃ', 'ト': 'ﾄ',
      'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ', 'ハ': 'ﾊ', 'ヒ': 'ﾋ', 'フ': 'ﾌ', 'ヘ': 'ﾍ', 'ホ': 'ﾎ',
      'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ', 'ヤ': 'ﾔ', 'ユ': 'ﾕ', 'ヨ': 'ﾖ',
      'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ', 'ワ': 'ﾜ', 'ン': 'ﾝ',
      '゛': 'ﾞ', '゜': 'ﾟ',
      'ヴ': 'ｳﾞ',
      'ガ': 'ｶﾞ', 'ギ': 'ｷﾞ', 'グ': 'ｸﾞ', 'ゲ': 'ｹﾞ', 'ゴ': 'ｺﾞ',
      'ザ': 'ｻﾞ', 'ジ': 'ｼﾞ', 'ズ': 'ｽﾞ', 'ゼ': 'ｾﾞ', 'ゾ': 'ｿﾞ',
      'ダ': 'ﾀﾞ', 'ヂ': 'ﾁﾞ', 'ヅ': 'ﾂﾞ', 'デ': 'ﾃﾞ', 'ド': 'ﾄﾞ',
      'バ': 'ﾊﾞ', 'ビ': 'ﾋﾞ', 'ブ': 'ﾌﾞ', 'ベ': 'ﾍﾞ', 'ボ': 'ﾎﾞ',
      'パ': 'ﾊﾟ', 'ピ': 'ﾋﾟ', 'プ': 'ﾌﾟ', 'ペ': 'ﾍﾟ', 'ポ': 'ﾎﾟ',
    };
  }
// 項番2581 START
  /**
   * 半角文字と全角文字のマップを取得する(HalftoFull)
   */
     static get getLetterObjectHalfTofull(): object {
      return {
        '0': '０', '1': '１', '2': '２', '3': '３', '4': '４', '5': '５', '6': '６', '7': '７', '8': '８', '9': '９',
        'A': 'Ａ', 'B': 'Ｂ', 'C': 'Ｃ', 'D': 'Ｄ', 'E': 'Ｅ', 'F': 'Ｆ', 'G': 'Ｇ', 'H': 'Ｈ', 'I': 'Ｉ', 'J': 'Ｊ',
        'K': 'Ｋ', 'L': 'Ｌ', 'M': 'Ｍ', 'N': 'Ｎ', 'O': 'Ｏ', 'P': 'Ｐ', 'Q': 'Ｑ', 'R': 'Ｒ', 'S': 'Ｓ', 'T': 'Ｔ',
        'U': 'Ｕ', 'V': 'Ｖ', 'W': 'Ｗ', 'X': 'Ｘ', 'Y': 'Ｙ', 'Z': 'Ｚ',
        'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ', 'f': 'ｆ', 'g': 'ｇ', 'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ',
        'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ', 'o': 'ｏ', 'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ',
        'u': 'ｕ', 'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ', 'z': 'ｚ',
        ' ': '　', '!': '！',            '#': '＃',           '%': '％', '&': '＆',            '(': '（', ')': '）',
        '*': '＊', '+': '＋',            '-': '－', '.': '．', '/': '／', ':': '：',           '<': '＜', '=': '＝',
        '>': '＞', '?': '？',            '[': '［', '\\': '￥', ']': '］', '^': '＾', '_': '＿', '`': '‘', '{': '｛',
        '|': '｜', '}': '｝',                       '｢': '「', '｣': '」',            
        'ｦ': 'ヲ', 'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ', 'ｯ': 'ッ',
        'ｰ': 'ー',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ', 'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ', 'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ', 'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ', 'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ', 'ﾜ': 'ワ', 'ﾝ': 'ン',
        'ﾞ': '゛', 'ﾟ': '゜',
      };
    }
// 項番2581 END

  /**
   * XMLのタグ内で使用できない文字をエスケープする("&" → "&amp;", "<" → "&lt;", ">" → "&gt;")
   *
   * @param value エスケープ対象文字列
   */
  static escapeXML(value: string) {
    if (value === null) {
      return value;
    }

    return value.replace(/[&<>]/g, char => {
      return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
      }[char];
    });
  }

  /**
   * 指定の文字列からタブを取り除く
   *
   * @param value 処理対象文字列
   * @return タブを取り除いた後の文字列
   */
  static trimTab(value: string): string {
    if (value == null) {
      return value;
    }
    if (value.indexOf('\t') < 0) {
      return value;
    }
    return value.split('\t').join('');
  }

  /**
   * ブラウザの「戻る」を禁止する
   */
  static backBlock() {
    history.pushState(null, null, null);
    window.addEventListener('popstate', () => {
        history.pushState(null, null, null);
    });
  }

  /**
   * 文字列を数値に変換して返す(空は0ではなくnullを返す)
   * @param value 変換する文字列
   * @return 数値(空の場合null)
   */
  static stringToNumber(value: string): number {
    if (PlessViewUtils.isEmpty(value)) {
      return null;
    } else {
      return Number(value);
    }
  }

  /**
   * 数値を文字列に変換して返す(nullの場合はnullを返す)
   * @param value 変換する数値
   * @return 文字列
   */
  static numberToString(value: number): string {
    if (value == null) {
      return null;
    } else {
      return value.toString();
    }
  }

  // 項番2231 START 障害管理NO.U01826対応
  /**
   * 対象の文字列がNULLもしくは空白の場合、0を返却する
   * @param source 検証対象文字列
   * @return 返却文字列
   */
  static nullToZero(source: string): string {
    return this.isEmpty(source) ? '0' : source;
  }
  // 項番2231 END 障害管理NO.U01826対応

  // TODO: shuto layerX, layerYの代替となるプロパティを確認する
  /**
   * マウスイベントのレイヤーXの値を返す.
   * @param event 
   * @returns 
   */
  static getLayerX(event: MouseEvent): number {
    return event.offsetX;
  }

  /**
   * マウスイベントのレイヤーYの値を返す.
   * @param event 
   * @returns 
   */
  static getLayerY(event: MouseEvent): number {
    return event.offsetY;
  }

}
